export const cachePages = Object.create(null);
export const dightExp = /[^\w|\d]/gi;
// export function replaceCache(oldKey: string, newKey: string) {
//   oldKey = oldKey.replace(dightExp, "");
//   newKey = newKey.replace(dightExp, "");
//   for (const key in cachePages) {
//     if (key != oldKey) {
//       continue;
//     }
//     if (Object.prototype.hasOwnProperty.call(cachePages, key)) {
//       const element = cachePages[key];
//       delete cachePages[key];
//       cachePages[newKey] = element;
//     }
//   }
// }
export function pruneCacheEntry(vnode: any) {
  if (vnode) {
    vnode.componentInstance.$destroy();
    vnode.keepAlive = false;
  }
}

export function pruneCache(cache: any, current: any, filter: any) {
  for (const key in cache) {
    const cachedNode = cache[key];
    if (cachedNode) {
      const name = key;
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          // console.log(`prune cache ${key}`);
          pruneCacheEntry(cachedNode);
        }
        // else {
        //   console.log(`null cache ${key}`);
        // }
        cache[key] = null;
      }
    }
  }
}

export function removeKeepalive(key: string) {
  key = key.replace(dightExp, "");
  const cache = cachePages[key];
  if (cache) {
    cache.keepAlive = false;
  }
  cachePages[key] = null;
}
